import { fromJS } from 'immutable';

import Client from 'models/ClientModel';

import { generateReducer } from '../../utils/HttpReducerHelper';

import {
  allClients,
  client,
  updateClientNote,
  updateClientPreview,
  assignTag,
  unassignTag,
  SET_MONITOR_STATUS_FILTERS,
  SET_MONITOR_ARCHIVED_VIEW,
  SET_MONITOR_TAGS_FILTERS,
  SET_MONITOR_PROPERTIES_FILTERS,
  REMOVE_MONITOR_FILTERS,
  SET_WIZZARD_REDIRECT_CLIENT_ID,
  CHANGE_CLIENTS_LOADING_STATE,
  SET_CLIENT_GENERATED_AT,
  SET_MONITOR_FILTER_BY_MANAGER,
} from './types';

export * from './actions';

const initialState = fromJS({
  byId: {},
  clients: {
    ids: [],
    network: { loading: false, error: false },
    listLoading: false,
  },
  fundingSearches: {
    network: { loading: false, error: false },
  },
  wizzardRedirectClientId: null,
  filters: {
    status: ['All clients'],
    properties: {},
    tags: [],
  },
  archivedView: false,
  selectedManager: {},
});

const allClientsReducer = generateReducer('clients', Client.deserialize);

const setArchivedView = (state, action) => state.setIn(['archivedView'], action.value);
const setMonitorStatusFilters = (state, action) =>
  state.setIn(['filters', 'status'], fromJS(action.filters));
const setMonitorPropertiesFilters = (state, action) =>
  state.setIn(['filters', 'properties'], fromJS(action.filters));
const setMonitorTagsFilters = (state, action) =>
  state.setIn(['filters', 'tags'], fromJS(action.filters));
const removeMonitorFilters = (state) =>
  state.withMutations((s) =>
    s
      .setIn(['filters', 'status'], fromJS([]))
      .setIn(['filters', 'properties'], fromJS({}))
      .setIn(['filters', 'tags'], fromJS([])),
  );

const setMonitorWizzardRedirectClientId = (state, action) =>
  state.set('wizzardRedirectClientId', action.id);

const setSelectedManager = (state, action) => state.set('selectedManager', action.user);

const setMonitorClientSuccess = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['byId', action.id], Client.deserialize(action.response))
      .setIn(['clients', 'network', 'loading'], false)
      .setIn(['clients', 'network', 'error'], false),
  );

const setClientPreview = (state, action) =>
  state.withMutations((currentState) =>
    currentState.mergeIn(['byId', Number(action.id), 'preview'], action.response),
  );

const setClientPreviewGeneratedId = (state, action) =>
  state.withMutations((currentState) => {
    if (currentState.getIn(['byId', Number(action.payload.entityId), 'preview'])) {
      return currentState.mergeIn(['byId', Number(action.payload.entityId), 'preview'], {
        generatedAt: action.payload.date,
      });
    }
  });

const setUnassignEntityTags = (state, action) =>
  state.withMutations((currentState) => {
    const assignedTags = state.getIn(['byId', Number(action.entityId), 'assignedTags']);

    return currentState.setIn(
      ['byId', Number(action.entityId), 'assignedTags'],
      assignedTags.filter((tag) => tag.assignmentId !== action.tagId),
    );
  });

const setAssignEntityTag = (state, action) =>
  state.withMutations((currentState) =>
    currentState.mergeIn(['byId', Number(action.entityId), 'assignedTags'], [action.tagData]),
  );

const changeClientsLoadingState = (state, action) =>
  state.withMutations((currentState) =>
    currentState.setIn(['clients', 'listLoading'], action.loadingState),
  );

export default function monitorReducer(state = initialState, action) {
  switch (action.type) {
    case updateClientNote.request:
      return allClientsReducer.request(state);
    case updateClientNote.success:
      return setMonitorClientSuccess(state, action);

    case allClients.request:
      return allClientsReducer.request(state);
    case allClients.success:
      return allClientsReducer.success(state, action);
    case allClients.failure:
      return allClientsReducer.failure(state, action);

    case client.request:
      return allClientsReducer.request(state);
    case client.success:
      return setMonitorClientSuccess(state, action);
    case client.failure:
      return allClientsReducer.failure(state, action);

    case updateClientPreview:
      return setClientPreview(state, action);

    case SET_CLIENT_GENERATED_AT:
      return setClientPreviewGeneratedId(state, action);

    case unassignTag:
      return setUnassignEntityTags(state, action);
    case assignTag:
      return setAssignEntityTag(state, action);

    case SET_MONITOR_ARCHIVED_VIEW:
      return setArchivedView(state, action);
    case SET_MONITOR_STATUS_FILTERS:
      return setMonitorStatusFilters(state, action);
    case SET_MONITOR_PROPERTIES_FILTERS:
      return setMonitorPropertiesFilters(state, action);
    case SET_MONITOR_TAGS_FILTERS:
      return setMonitorTagsFilters(state, action);
    case REMOVE_MONITOR_FILTERS:
      return removeMonitorFilters(state);

    case CHANGE_CLIENTS_LOADING_STATE:
      return changeClientsLoadingState(state, action);
    case SET_WIZZARD_REDIRECT_CLIENT_ID:
      return setMonitorWizzardRedirectClientId(state, action);

    case SET_MONITOR_FILTER_BY_MANAGER:
      return setSelectedManager(state, action);

    default:
      return state;
  }
}
